import { render, staticRenderFns } from "./pt-mode-switcher.vue?vue&type=template&id=7b0e0c30&"
import script from "./pt-mode-switcher.vue?vue&type=script&lang=js&"
export * from "./pt-mode-switcher.vue?vue&type=script&lang=js&"
import style0 from "./pt-mode-switcher.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports